import React from "react";
import "./FinishNewNote.css";

function FinishNewNote(props: {callback: () => void}): JSX.Element {
    return (
        <div className="finishNewNote" onClick={props.callback}>
            <p className="finishNewNoteText">Finish</p>
        </div>
    )
}

export default FinishNewNote;